import TopHorizontalMenuItem from './TopHorizontalMenuItem'

export default TopHorizontalMenuItem
